import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { OneEmptyState } from '@factorialco/f0-react/dist/experimental'
import Upsell from '@factorialco/f0-react/icons/app/Upsell'

import { useEffect } from 'modules/core/hooks/useEffect'
import i18n from 'modules/core/lib/i18n'

import { ProductModal } from 'modules/upselling_kit/components/ProductModal'
import { UpsellGuard } from 'modules/upselling_kit/components/UpsellGuard'
import { UpsellingKitEmptyState } from 'modules/upselling_kit/types'
import { handleUpsellingVisibility } from 'modules/upselling_kit/utils/handlers'

const EmptyStateContent = ({
  moduleRequested,
  title,
  description,
  requestSource,
  requestReason,
  featureRequested,
  background = '',
  learnMoreNavigate,
  variant = 'page',
  buttonLabel,
}: UpsellingKitEmptyState) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  useEffect(() => {
    handleUpsellingVisibility({
      moduleRequested,
      requestSource,
      component: 'empty_state',
    })
  }, [moduleRequested, requestSource])

  return (
    <Box
      width="full"
      justifyContent="center"
      alignItems="center"
      position="relative"
      style={{
        height: variant === 'card' ? '100%' : variant === 'table' ? '720px' : '100vh',
        overflow: 'hidden',
      }}
    >
      <Box
        position="absolute"
        width="full"
        height="full"
        style={{
          backgroundImage: `url(${background})`,
          backgroundPosition: 'top center',
          filter: 'blur(4px)',
        }}
      />
      <OneEmptyState
        title={title || ''}
        description={description || ''}
        emoji={'⚡️'}
        actions={[
          {
            icon: Upsell,
            label: buttonLabel || i18n.t('upselling_kit.button.more_info'),
            onClick: handleOpenModal,
            type: 'default',
            variant: 'outline',
          },
        ]}
      />
      {isModalOpen && (
        <ProductModal
          moduleRequested={moduleRequested}
          requestReason={requestReason}
          featureRequested={featureRequested}
          pageSource={requestSource}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          learnMoreNavigate={learnMoreNavigate}
          requestSource={requestSource}
          upsellRequestComponentType="empty_state"
        />
      )}
    </Box>
  )
}

const EmptyState = ({
  title,
  description,
  fallbackComponent,
  buttonLabel,
  ...upsellProps
}: UpsellingKitEmptyState) => {
  return (
    <UpsellGuard {...upsellProps} fallbackComponent={fallbackComponent || null}>
      <EmptyStateContent
        {...upsellProps}
        title={title}
        description={description}
        buttonLabel={buttonLabel}
      />
    </UpsellGuard>
  )
}
export { EmptyState }
